<template>
  <div>
    <van-nav-bar
        title="商家收款账号"
        left-arrow
        :fixed="true"
        class="my-nav"
        @click-left="$router.back(-1)"
        :z-index="100"
    />
    <div style="margin-top: 20%;margin-left: 16px;">
      <div
          style="height: 120px; margin-right:3.4%;margin-top: 20px;background-color: #FEFEFE;border: solid 1px #f0f0f0;border-radius: 5px;box-shadow: 3px -3px 6px #f2f2f2 "
          v-for="(bank,index) in bankList"
          :key="index">
        <div>
          <img style="height: 33px;width: 150px;padding: 10px;" v-if="isImg(bank.name) != undefined"
               :src="imgUrl(bank.name)"/>
          <p style="font-size: 14px;padding-left: 10px;" v-else>{{ bank.name == '' ? '-------' : bank.name }}</p>
        </div>
        <div style="border-bottom: 1px dashed #f0f0f0;padding-left: 10px;">{{ bank.card }}</div>
        <div style="padding: 10px 0 10px 10px;">
          <div style="font-size: 14px;float: left;">{{ bank.accountName }}</div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {img} from '../../api/ql-bank-card'

export default {
  data() {
    return {
      bankList: [{
        card: "86611742101421002321",
        name: "齐鲁银行",
        accountId: "11",
        accountName: "山东德恩怡华通信科技有限公司"
      },
        {
          card: "8112501011801574691",
          name: "中信银行",
          accountId: "20",
          accountName: "山东捷盛途电子科技有限公司"
        },
        {
          card: "8112501013301803706",
          name: "中信银行",
          accountId: "25",
          accountName: "山东润盈通信设备有限公司"
        },
        {
          card: "000000737003800006023",
          name: "齐鲁银行",
          accountId: "15159",
          accountName: "山东金怡华公司（新业务）"
        }],
    }
  },

  methods: {
    imgUrl(bankName) {
      var bankNameUrl = img.getUrl(bankName);
      return require('@/assets/images/bank/' + bankNameUrl + '.png');
    },
    isImg(bankName) {
      return img.isImg(bankName);
    },
  }
}
</script>

<style lang="less" scoped>
.van-address-list__add {
  height: 50px;
}
</style>
